import { jsx as _jsx } from "react/jsx-runtime";
import { isSameDay } from 'date-fns';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Popup, SouthWest } from '../../utils/popups';
import { Calendar } from '../Calendar';
import { AbstractPopup, } from './AbstractPopup';
export function CalendarPopup({ date, onDateChange, resolve, ...props }) {
    const [previousDate, setPreviousDate] = useState(date);
    useEffect(() => {
        setPreviousDate(date);
    }, [date]);
    return (_jsx(CalendarPopupRoot, { ...props, translateFn: SouthWest, children: _jsx(Calendar, { value: date, onChange: (value) => {
                if (isSameDay(previousDate, value)) {
                    resolve();
                    return;
                }
                setPreviousDate(value);
                onDateChange?.(value);
            } }) }));
}
const calendarPopup = Popup.create(CalendarPopup);
const CalendarPopupRoot = styled(AbstractPopup) `
    --Popup_BackgroundOpacity: 0.2;
    --Popup_InitialScale: 0.98;
    --Popup_OffsetY: 0.5rem;
    --Popup_BorderRadius: 0.75rem;
    --Popup_Padding: 0;
    --Popup_Width: auto;
    --Popup_MaxWidth: calc(var(--vw-100, 100vw) - 1rem);
    --Popup_X: min(var(--Popup_AnchorX, 0rem), calc(100vw - 100% - 0.5rem));
    --Popup_Y: min(
        var(--Popup_AnchorY, 0rem),
        calc(var(--vh-100, 100vh) - 100% - 1rem)
    );
`;
export function showCalendar(date, options = {}) {
    (async () => {
        options.onBeforeOpen?.();
        try {
            await calendarPopup.pop({
                date,
                onDateChange: options.onDateChange,
                anchorRef: options.anchorRef,
                controllerRef: options.controllerRef,
            });
        }
        catch (_ignored) {
            // Do nothing.
        }
        finally {
            options.onAfterClose?.();
        }
    })();
}
